export const myUtil = {
  formatDate (date) {
    let str = date.getFullYear()
    let mon = date.getMonth() + 1
    str += "-"
    str += (mon > 9) ? mon.toString() :  "0" + mon
    str += "-"
    str += (date.getDate() > 9) ? date.getDate().toString() :  "0" + date.getDate()
    str += " "
    str += (date.getHours() > 9) ? date.getHours().toString() :  "0" + date.getHours()
    str += ":"
    str += (date.getMinutes() > 9) ? date.getMinutes().toString() :  "0" + date.getMinutes()
    str += ":"
    str += (date.getSeconds() > 9) ? date.getSeconds().toString() :  "0" + date.getSeconds()
    return str
  },
    isValidURL(str_url) {// 验证url
        var strRegex = "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
            + "|" // 允许IP和DOMAIN（域名）
            + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
            + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
            + "[a-z]{2,6})" // first level domain- .com or .museum
            + "(:[0-9]{1,4})?" // 端口- :80
            + "((/?)|" // a slash isn't required if there is no file name
            + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
        var re = new RegExp(strRegex);
        return re.test(str_url);
    },
    parseTime(time, cFormat) {
        if (arguments.length === 0) {
            return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
            date = time
        } else {
            if (('' + time).length === 10) time = parseInt(time) * 1000
            date = new Date(time)
        }
        const formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay()
        }
        const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
            let value = formatObj[key]
            if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
            if (result.length > 0 && value < 10) {
                value = '0' + value
            }
            return value || 0
        })
        return time_str
    },
    // 过滤需要的数据,同时对时间字段需要做转化，否则会无法正确显示时间
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
            if (j === 'updateTime') {
                return this.parseTime(v[j])
            } else {
                return v[j]
            }
        }))
    },
}